import { Navigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/web/rootRoutes";
import authManager from "../utils/authManager";

const PartnerAuth = ({ children }) => {
  
  if (authManager.hasAccessToken() && authManager.getRole() === "Partner") {
     return children;
  } else {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }
};

export default PartnerAuth;
